import { useQueryProjectUsers } from '@api/hooks/project/projectQuery';

export function useGetProjectMembers({ activeProject, skip, rowsPerPage }) {
  return useQueryProjectUsers({ activeProject, skip, rowsPerPage });
}
